import React, { useEffect, useState } from "react";
import {useLocation} from "react-router-dom";
import { useGetPasswordResetIsResetLinkValidByResetIdQuery, usePostPasswordResetResetPasswordMutation } from "redux/vmsApi";
import ResetPasswordForm from "./ResetPasswordForm";
import ResetPasswordSuccess from "./ResetPasswordSuccess";
import ResetPasswordError from "./ResetPasswordError";
import {Container, Paper, Box} from "@mui/material";
import {styled} from "@mui/material/styles";
import {useRouter} from "../../../hooks/useRouter";

const FullPageContainer = styled(Container)({
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '24px',
  background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)',
});

const ContentPaper = styled(Paper)({
  borderRadius: '16px',
  overflow: 'hidden',
  boxShadow: '0 8px 40px rgba(0, 0, 0, 0.12)',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '600px',
});

const ContentBox = styled(Box)(({theme}) => ({
  padding: '48px 32px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'white',
  height: '100%',
  [theme.breakpoints.down('md')]: {
    padding: '32px 24px',
  },
}));


const ResetPasswordPage = () => {
  const { search } = useLocation();
  const router = useRouter();
  const [resetRequestId, setResetRequestId] = useState<string>('')
  const [apiError, setApiError] = useState<string>('')
  const [sendReset, {isSuccess: isPasswordResetSuccess, isLoading: isPasswordResetLoading, error: passwordResetError}] = usePostPasswordResetResetPasswordMutation();
  const {isError: isResetValidError, isLoading: isResetValidLoading} = useGetPasswordResetIsResetLinkValidByResetIdQuery({resetId: resetRequestId ?? ''}, {skip: resetRequestId === ''});

  useEffect(() => {
    const searchParams = new URLSearchParams(search );
    const resetReference = searchParams.get('reset_reference');

    if(resetReference === null || resetReference === undefined || resetReference === '') {
      router.push('/')
    }
    else {
      setResetRequestId(resetReference)
    }
  }, [search, history])

  useEffect(() => {
    if(passwordResetError && 'data' in passwordResetError) {
      const newErr:any = passwordResetError.data
      if(newErr?.error?.message)
        setApiError(newErr?.error?.message as string)
    }
  }, [passwordResetError, setApiError])


  const doneClickHandler = () => {
    router.push('/')
  }

  const sendResetHandler = async (newPassword: string) => {
    setApiError('')
    sendReset({
      body: {
        password: newPassword,
        resetRequestId
      }
    })
  }

  return (
    <FullPageContainer maxWidth={false}>
      <ContentPaper elevation={0}>
        <ContentBox>
          {
            (isResetValidError && !isPasswordResetSuccess) ?
              <ResetPasswordError
                doneClickHandler={doneClickHandler}
              />
              :
              isPasswordResetSuccess ?
                <ResetPasswordSuccess
                  doneClickHandler={doneClickHandler}
                />
                :
                <ResetPasswordForm
                  isLoading={isPasswordResetLoading || isResetValidLoading}
                  sendReset={sendResetHandler}
                  apiError={apiError}
                />
          }
        </ContentBox>
      </ContentPaper>
    </FullPageContainer>
  )
}

export default ResetPasswordPage;
